import React, { Component } from 'react';
import '../css/App.css';
import API from '../config_api'
import axios from 'axios'
import Sidenav from './Sidenav'

import Footer from '../component/Footer';
class Resume extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

        };

    }

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/')
        }
        let formData = new FormData();
        formData.append('userid', localStorage.getItem('token'))
        axios({
            method: 'post',
            url: API.PauseUnit,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                console.log(res.data.data)

                this.setState({ data: res.data.data })

            });
    }
    btnAction(data) {
        console.log(data);
        this.props.history.push('/pause/' + data.id, { data })
        
    }


    render() {
        return (
            <div className="">
            {/* <IdleTimerLogout/> */}
            {/* <Sidenav type={'second'} url={'/dashboard'} /> */}
            <nav class="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 1
                    }}>
                    <div class="container pad_z">
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-sm-3 pad_z ">
                                <i className="material-icons back-btn grey-text" onClick={() => this.props.history.push('/dashboard')}>arrow_back</i>
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{fontSize:20}}> Resume</div>
                            <div className="col-sm-3 text-right  pad_z vertical-align justify-content-end"></div>

                        </div>
                    </div>
                </nav>

            <div className="container" style={{marginTop:30}}>
            <div style={{position:'fixed',left:0,right:0,zIndex:1,background:'#F8F9FE'}}>
                    <div className="container">
                    <div className="row">
                       
                        {/* <div className="col-md-12 text-center" style={{ padding: 15 }}>
                            <h5 className="size-text">Resume</h5>
                        </div> */}
                    </div>
                  </div>
                  </div>
                  <div style={{height:60}}></div>
                <div className="row">
                
                    <div className="col-sm-12">
                        <div className="trans">
                        {this.state.data.map((data, i) =>
                                <div className="unit_assign col-sm-12 " style={{fontSize:'15px'}} key={i} onClick={() => this.btnAction(data)}>
                                     <div className="col-sm-11 col-xs-11 pad_z">{data.title}
                                     <p className=" mZero">{data.created_at}</p>
                                     </div>
                                    <div className="col-sm-1 col-xs-1 pad_z"><i className="material-icons">
                                        keyboard_arrow_right
</i></div>

                                </div>)}
                        </div>
                        </div>
                </div>
                </div>
                <Footer page="resume" Push={this.props.history} />
                </div>
        )
    }
}
export default Resume;